import(/* webpackMode: "eager" */ "/codebuild/output/src1231141291/src/src/app/page.tsx");
